// Palette
import palette from 'theme/palette';
function filterMinutes(x) {
  if(x.split(":").pop()%15 === 0) {
    return x;
  } else {
    return "";
  }
}
function filterHour(x) {
  if(x.split("-").pop()%6 === 0) {
    return x;
  } else {
    return "";
  }
}
function filterDate(x) {
  if(x.endsWith("-0")) {
    return x.split("-")[0];
  } else {
    return "";
  }
}
function filterDateWithIndex(x, index) {
  if(x.endsWith("-0") && index % 7 == 0) {
    return x.split("-")[0];
  } else {
    return "";
  }
}
// Chart options
export const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  legend: { display: true },
  cornerRadius: 20,
  tooltips: {
    enabled: true,
    mode: 'index',
    intersect: false,
    borderWidth: 1,
    borderColor: palette.border,
    backgroundColor: palette.common.white,
    titleFontColor: palette.text.primary,
    bodyFontColor: palette.text.secondary,
    footerFontColor: palette.text.secondary
  },
  layout: { padding: 0 },
  scales: {
    xAxes: [
      {
        ticks: {
          fontColor: palette.text.secondary,
          maxRotation: 0,
          autoSkip: false
        },
        afterBuildTicks: function(axis, ticks) {
          if(ticks.length == 60)
            return ticks.map(filterMinutes);
          else if(ticks.length == 24)
            return ticks.map(filterHour);
          else if(ticks.length == 144)
            return ticks.map(filterDate);
          else
            return ticks.map(filterDateWithIndex);
        },
        gridLines: {
          display: false,
          drawBorder: false
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          fontColor: palette.text.secondary,
          beginAtZero: true,
          min: 0
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: palette.divider
        }
      }
    ]
  }
};
